import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm, Popover,
} from 'antd';

import { asyncGet, actions,reget } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import { delect, delectAll } from './reducers';

class WXAccount extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    reStart = record => {
        const { scriptId } = record;
        this.props.reStart({ scriptIds: [scriptId], action: '7', executeNow: true });
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record._id);
    }
    regetAccount = async  record => {
      //  this.props.changeCurrentSelectId(record._id);
       await this.props.reget(record._id);
       this.props.asyncGet();
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        await this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        return (
            <div>
            {/*    <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
                    编辑
                </Button>*/}
                <Popconfirm title="是否重新获取?" onConfirm={() => { this.regetAccount(record); }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">重新获取</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = (selectedRowKeys, selectedRows) => { //selectedRowKeys  指定选中项的 key 数组
        this.props.getTransferData({ selectedRowKeys });
        this.props.getSele(selectedRowKeys);
    }

    render() {
        let { list, uiStatus, pagination, transferData } = this.props;
        const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const columns = [
            {
                title: '公众号名称',
                dataIndex: 'accountName',
                key: 'accountName',
            },
            {
                title: '账号名称',
                dataIndex: 'pubAccount',
                key: 'pubAccount',
            },
            {
                title: '设备号',
                dataIndex: 'clientId',
                key: 'clientId',
            },
            {
                title: '是否获取',
                dataIndex: 'noGet',
                key: 'noGet',
                render: (value) => {
                    return value == 1? '未获取':'已获取';
                }
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            ...pagination,
                        }}
                        defaultExpandAllRows={false}
                        onChange={this.changeHandle}
                        rowSelection={rowSelection}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedContent: state.wxAccount.selectedContent,
    list: state.wxAccount.list,
    pagination: state.wxAccount.pagination,
    proxyrepeatinfo: state.wxAccount.proxyrepeatinfo,
    uiStatus: state.wxAccount.uiStatus,
    agentsGroup: state.wxAccount.agentsGroup,
    transferData: state.wxAccount.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delUser: id => dispatch(actions.del(id)),
    delect: record => dispatch(delect(record)),
    delectAll: selectedRowsCurr1 => dispatch(delectAll(selectedRowsCurr1)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    getUserGroups: () => dispatch(getUserGroups()),
    getSele: data => dispatch(actions.getSele(data)),
    editShowValues: () => dispatch(actions.changeUiStatus({ isUpdateShowValue: true })),
    reget: data => dispatch(reget(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(WXAccount);



// WEBPACK FOOTER //
// ./pages/client/wxAccount/index.js